import React from "react";
import { Button, Callout, Classes, Dialog, Intent } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";

interface ISuccessDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

const SuccessDialog: React.FC<ISuccessDialogProps> = ({ isOpen, onClose }) => {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="Sync Schedule Updated"
      icon={IconNames.TICK_CIRCLE}
    >
      <div className={Classes.DIALOG_BODY}>
        <Callout intent={Intent.SUCCESS}>
          Sync schedule has been updated successfully.
        </Callout>
      </div>
      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button
            intent={Intent.PRIMARY}
            onClick={onClose}
          >
            OK
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default SuccessDialog;
